/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Save_TitleInputs */

const en_pc_online_task_save_title = /** @type {(inputs: Pc_Online_Task_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your work`)
};

const zh_pc_online_task_save_title = /** @type {(inputs: Pc_Online_Task_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存成果`)
};

/**
* | output |
* | --- |
* | "Save your work" |
*
* @param {Pc_Online_Task_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_save_title = /** @type {((inputs?: Pc_Online_Task_Save_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Save_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_save_title(inputs)
	return zh_pc_online_task_save_title(inputs)
});
export { pc_online_task_save_title as "pc.online.task.save.title" }